module.exports = __webpack_public_path__ + "static/img/icon_logo3.59aa236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_logo3.png
// module id = +nIz
// module chunks = 1